import SideBar from './SideBar/SideBar.js';
import MessageBlock from './MessageBlock/MessageBlock.js';
import ChatComposer from './ChatComposer/ChatComposer.js';
import ModelDropdown from './ModelDropdown/ModelDropdown.js';
import Portal from './Portal.js';
import Error from './Error/Error.js';
import styles from './Pages.module.css';
import { useRef } from 'react';

function MessagePage() {

  const contentBlockRef = useRef(null);
  
  return (
    <div className={styles.layout}>
      <Portal >
        <Error />
      </Portal>
      <SideBar />
      <ModelDropdown />
      <div ref={contentBlockRef} className={styles.content}>
        <div className={styles.main}>
          <MessageBlock scrollTargetRef={contentBlockRef} />
          <ChatComposer />
        </div>
      </div>
    </div>
  );
}
  
export default MessagePage;